import React, { useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import Moment from 'moment';
import { clicPintado, clicPintadoPC } from "../queries/Mutations";

function Pintado({
  sProduccion,
  bColor,
  btitle,
  modulo,
  usuario,
  valorDeREtorno,
  proceso,
}) {


  const [cargando, setCargando] = useState(false);
  const [fecha, setfecha] = useState(new Date());
  const [fechaPintado, setfechaPintado] = useState(Moment(fecha).format("YYYY-MM-DD"));



  async function aceptarPintadoPP() {
    setCargando(true);
    const pProduccionPintado = [sProduccion];
    const result = (proceso === "PowderCoat") ? await clicPintadoPC(pProduccionPintado, fechaPintado, usuario, modulo) :
      await clicPintado(pProduccionPintado, fechaPintado, usuario, modulo);;
    setCargando(false);
    valorDeREtorno(result);
  }

  return (
    <>
      {cargando === true && (
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
          <img width="150px" src="assets/img/preloader.gif" />
        </div>
      )}
      {cargando === false && (
        <button
          class={"btn-" + bColor + " cbutton"}
          title={btitle}
          onClick={() => aceptarPintadoPP()}
        >
          <IoIcons.IoIosBrush />
        </button>
      )}
    </>
  );
}
export default Pintado;
